import HttpService from "../base/HttpService";

export default class LegalService extends HttpService {
  static api = process.env.VUE_APP_BASE_API;

  // HUMAN CAPITAL //////////////////////////////////////////////////////////////////
  getData(param) {
    const api = this.api + "legal/human-capital";
    return this.get(param, api);
  }

  getDataOrganizational(param) {
    const api = this.api + "legal/human-capital/organizational/" + param.id;
    let setParam = {
      directorate: param.directorate,
    };
    return this.get(setParam, api);
  }

  getDataExcellence(param) {
    const api = this.api + "legal/human-capital/excellence/" + param.id;
    let setParam = {
      directorate: param.directorate,
      ratio: param.ratio,
    };
    return this.get(setParam, api);
  }

  getDataEfficiencyPersonel(param) {
    const api = this.api + "legal/human-capital/efficiency";
    let setParam = {
      id: param.id,
      type: param.type,
      department: param.department,
    };
    return this.get(setParam, api);
  }

  getOcrScore(param) {
    const api = this.api + "legal/human-capital/ocr-score";
    let setParam = {
      directorate: param.directorate,
      category: param.category,
      status: param.status,
    };
    return this.get(setParam, api);
  }

  getFemaleRatio(param) {
    const api = this.api + "legal/human-capital/female-ratio";
    let setParam = {
      directorate: param.directorate,
      type: param.valueBy,
    };
    return this.get(setParam, api);
  }

  getDataMilenialRatio(param) {
    const api = this.api + "legal/human-capital/millennial-ratio";
    let setParam = {
      directorate: param.directorate,
      type: param.valueBy,
    };
    return this.get(setParam, api);
  }

  getDataDigitalRatio(param) {
    const api = this.api + "legal/human-capital/digital-ratio";
    let setParam = {
      directorate: param.directorate,
      "%5B%27BY_UNIT_INDUK%27%5D": param.valueBy,
    };
    return this.get(setParam, api);
  }

  getDetailSafety(param) {
     const api = this.api + `legal/human-capital/safety/${param.metricId}`;
     let setParam = {
       metricId: param.metricId,
       subdir: param.subdir,
       status: param.status,
     };
     return this.get(setParam, api);
  }

  // GENERAL AFFAIRS /////////////////////////////////////////////////////////////////

  getGeneralAffair(param) {
    const api = this.api + "legal/general-affairs";
    return this.get(param, api);
  }

  getGeneralAffairById(param) {
    const api = this.api + "legal/general-affairs/ga-detail";
    let setParam = {
      directorate: param.directorate,
      Target: param.Target,
      cities: param.cities,
    };
    return this.get(setParam, api);
  }

  getGeneralRevenueDetail(param) {
    const api = this.api + "legal/general-affairs/ga-revenue";
    let setParam = {
      directorate: param.directorate,
    };
    return this.get(setParam, api);
  }

  // LEGAL ///////////////////////////////////////////////////////////////////////////
  getLegal(param) {
    const api = this.api + "legal";
    return this.get(param, api);
  }
}
